// extracted by mini-css-extract-plugin
export default {"block":"QimRZDm65l7mlYA5zzqn","blockHeader":"lWwEIDXys1eVbOiDU_Kt","blockBody":"uaxkLRYvFJ2JfVPAsFU9","blockBodyRow":"VO1cQfaSLSMrmnTDAcXw","blockBodyRowItem":"Y51Md1nCCZ8aRVvVNYWG"};